/**
 * The part of an enum schema this helper actually uses. Declaring it structurally keeps
 * `parseSort` free of a zod import, so callers on either major satisfy it.
 */
interface SortSchema<T> {
  safeParse: (value: unknown) => { success: true; data: T } | { success: false };
}

export function parseSort<T>(schema: SortSchema<T>, value: unknown) {
  const result = schema.safeParse(value);

  if (!result.success) {
    return undefined;
  }

  return result.data;
}
